export function detectNigerianNetwork(phoneNumber) {
  if (!phoneNumber) return null;

  // 1. Strip non-numeric characters (spaces, dashes, etc.)
  let cleaned = phoneNumber.replace(/\D/g, "");

  // 2. Normalize country code formats (e.g., 234803... -> 0803...)
  if (cleaned.startsWith("234") && cleaned.length > 3) {
    cleaned = "0" + cleaned.slice(3);
  }

  // We need at least 4 digits (e.g., "0803") to match a prefix
  if (cleaned.length < 4) return null;

  const prefix4 = cleaned.slice(0, 4);
  const prefix5 = cleaned.slice(0, 5); // Some multi-links prefixes are 5 digits (e.g. 07025)

  // MTN Prefixes
  const mtn = ["0803", "0806", "0814", "0810", "0813", "0816", "0703", "0706", "0903", "0906", "0913", "0916", "0704", "0707"];
  const mtn5 = ["07025", "07026"];
  if (mtn.includes(prefix4) || mtn5.includes(prefix5)) return "MTN";

  // Airtel Prefixes
  const airtel = ["0802", "0808", "0812", "0701", "0708", "0902", "0907", "0901", "0912", "0911"];
  if (airtel.includes(prefix4)) return "AIRTEL";

  // Glo Prefixes
  const glo = ["0805", "0807", "0811", "0815", "0705", "0905", "0915"];
  if (glo.includes(prefix4)) return "GLO";

  // 9mobile Prefixes
  const nineMobile = ["0809", "0817", "0818", "0909", "0908"];
  if (nineMobile.includes(prefix4)) return "9MOBILE";

  return null;
}